import React, { useEffect, useState } from "react";
import { Formik, Field, ErrorMessage, Form, FieldArray } from "formik";
import * as Yup from "yup";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { handleKeyDown } from "../../../Common/FewCommonMethods";

const formdatatomap = [
  {
    title: "Project duration",
    name: "duration_type",
    placeholder: "Project duration",
  },
];

const ModalDuretion = ({ formData, setFormData, setModalduretion }) => {
  const initialValues = {
    duration_type: formData?.duration_type || 2,
    duration: formData?.duration,
  };

  const validationSchema = Yup.object().shape({
    duration_type: Yup.string().required("Project duration is required"),
    duration: Yup.string().required("Countduration is required"),
  });

  const handleSubmit = (values) => {
    setFormData((prevData) => ({
      ...prevData,
      ...values,
    }));
    setModalduretion((state) => !state);
  };

  return (
    <>
      {/* <ModalHeader toggle={() => setModalduretion(state => !state)}>Edit Duration</ModalHeader> */}
      <button
        onClick={() => setModalduretion((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Edit Duration</h4>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {(formik) => (
            <Form>
              {}
              {formdatatomap.map((prop, key) => {
                if (prop.name == "duration_type") {
                  return (
                    <div key={key}>
                      <div className="form-group">
                        <h6>{prop.title}</h6>
                        <div className="checkbox-label mb-3">
                          <label className="checkbox-container">
                            <Field
                              type="radio"
                              checked={formik.values[prop.name] == 2}
                              name={prop.name}
                              value="2"
                              onClick={() =>
                                formik.setFieldValue("duration", "")
                              }
                            />
                            <span className="checkmark"> Days</span>
                          </label>
                          <label className="checkbox-container">
                            <Field
                              type="radio"
                              checked={formik.values[prop.name] == 3}
                              name={prop.name}
                              value="3"
                              onClick={() =>
                                formik.setFieldValue("duration", "")
                              }
                            />
                            <span className="checkmark">Weeks</span>
                          </label>
                          <label className="checkbox-container">
                            <Field
                              type="radio"
                              checked={formik.values[prop.name] == 4}
                              name={prop.name}
                              value="4"
                              onClick={() =>
                                formik.setFieldValue("duration", "")
                              }
                            />
                            <span className="checkmark">Months</span>
                          </label>
                        </div>
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className="error"
                        />
                        {formik.values.duration_type ? (
                          <>
                            <Field
                              key={key}
                              value={formik.values.duration}
                              className="form-control"
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "duration",
                                  e.target.value,
                                );
                              }}
                              onKeyDown={handleKeyDown}
                              placeholder={`Enter number of ${formik.values.duration_type == 2 ? "Days" : formik.values.duration_type == 3 ? "Weeks" : formik.values.duration_type == 4 ? "Months" : ""}`}
                            />

                            <ErrorMessage
                              name="duration"
                              component="div"
                              className="error"
                            />
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  );
                }
              })}
              <div className="modal-footer ">
                {/* <button className='btn no' onClick={() => { setModaltitle(state => !state); hitApi() }}>No</button> */}
                <button className="btn" onClick={formik.handleSubmit}>
                  Save
                </button>
              </div>
              {/* <ModalFooter>
                                <Button color="primary" className="next-button"
                                    type="button"
                                    onClick={formik.handleSubmit}
                                > SAVE
                                </Button>
                            </ModalFooter> */}
            </Form>
          )}
        </Formik>
      </ModalBody>
    </>
  );
};

export default ModalDuretion;
